import React from 'react';
import PropTypes from 'prop-types';
import AutoComplete from 'react-google-autocomplete';

import SETTINGS from '../../settings';

const PlaceAutoCompleteInput = props => {
  const handleOnChange = e => {
    const value = e.target.value;

    props.onChange(value);
  };

  const handleOnPlaceSelected = (place, input) => {
    // TODO - save id? lat? lng?
    props.onChange(input.value);
  };

  return (
    <div className="bp5-input-group">
      <AutoComplete
        id={props.id}
        defaultValue={props.value}
        placeholder={props.placeholder}
        apiKey={SETTINGS.GOOGLE_API_KEY}
        language="en"
        options={{
          types: ['locality'],
        }}
        className="bp5-input"
        onChange={handleOnChange}
        onPlaceSelected={handleOnPlaceSelected}
        inputAutocompleteValue="off"
      />
    </div>
  );
};

PlaceAutoCompleteInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

export default PlaceAutoCompleteInput;
